/**
 * Announcement Templates for Live Auctions
 * Simple encouraging and welcoming messages ready to use
 * Supports English, Urdu, and Roman English (Urdu transliteration) languages
 */

export const announcementTemplates = [
    // English Templates
    {
        id: 'welcome',
        title: 'Welcome Message',
        language: 'en',
        message: 'Welcome to the live auction! Excited to have you here. Happy bidding!'
    },
    {
        id: 'encourage_bidding',
        title: 'Encourage Bidding',
        language: 'en',
        message: 'Don\'t miss out on these amazing items! Place your bids now and take home something special!'
    },
    {
        id: 'thank_participants',
        title: 'Thank Participants',
        language: 'en',
        message: 'Thank you all for participating in today\'s auction! Your enthusiasm makes this event special.'
    },
    {
        id: 'final_opportunity',
        title: 'Final Opportunity',
        language: 'en',
        message: 'This is your final opportunity! Don\'t let these incredible items slip away - place your bids now!'
    },
    {
        id: 'excitement',
        title: 'Build Excitement',
        language: 'en',
        message: 'The bidding is heating up! Get in on the action and secure your favorite items before they\'re gone!'
    },
    {
        id: 'appreciation',
        title: 'Show Appreciation',
        language: 'en',
        message: 'Thank you for your patience and participation. Your bids help make this auction a success!'
    },
    {
        id: 'momentum',
        title: 'Maintain Momentum',
        language: 'en',
        message: 'Keep the momentum going! Every bid counts and brings everyone closer to closing these amazing lots!'
    },
    {
        id: 'encourage_activity',
        title: 'Encourage Activity',
        language: 'en',
        message: 'The auction is in full swing! Join in and make your mark with a winning bid!'
    },
    {
        id: 'great_deals',
        title: 'Great Deals Available',
        language: 'en',
        message: 'Amazing deals are waiting for you! Don\'t hesitate - these prices won\'t last long!'
    },
    {
        id: 'community_spirit',
        title: 'Community Spirit',
        language: 'en',
        message: 'Thank you for being part of this auction community! Your participation creates a wonderful atmosphere!'
    },
    {
        id: 'competitive_bidding',
        title: 'Competitive Bidding',
        language: 'en',
        message: 'The competition is fierce! Show your determination and make that winning bid!'
    },
    {
        id: 'quality_items',
        title: 'Quality Items',
        language: 'en',
        message: 'These are exceptional items you won\'t find anywhere else! Secure yours today!'
    },
    {
        id: 'time_sensitive',
        title: 'Time Sensitive',
        language: 'en',
        message: 'Time is running out! Make sure you don\'t miss your chance to bid on these fantastic lots!'
    },
    {
        id: 'success_stories',
        title: 'Success Stories',
        language: 'en',
        message: 'Many bidders have already found their perfect items today! You could be next - keep bidding!'
    },
    {
        id: 'support_message',
        title: 'Support Message',
        language: 'en',
        message: 'Your support is greatly appreciated! Every bid helps make this auction a tremendous success!'
    },
    {
        id: 'energy_boost',
        title: 'Energy Boost',
        language: 'en',
        message: 'Let\'s keep the energy high! Your active participation drives the excitement of this auction!'
    },
    {
        id: 'value_reminder',
        title: 'Value Reminder',
        language: 'en',
        message: 'Remember, these items represent incredible value! Don\'t let great opportunities pass you by!'
    },
    // Urdu Templates
    {
        id: 'welcome_ur',
        title: 'خوش آمدید',
        language: 'ur',
        message: 'لائیو نیلامی میں خوش آمدید! آپ کو یہاں دیکھ کر خوشی ہو رہی ہے۔ خوش قسمت بولی!'
    },
    {
        id: 'encourage_bidding_ur',
        title: 'بولی لگانے کی حوصلہ افزائی',
        language: 'ur',
        message: 'ان شاندار اشیاء کو مت چھوڑیں! ابھی اپنی بولی لگائیں اور کچھ خاص گھر لے جائیں!'
    },
    {
        id: 'thank_participants_ur',
        title: 'شرکاء کا شکریہ',
        language: 'ur',
        message: 'آج کی نیلامی میں شرکت کے لیے آپ سب کا شکریہ! آپ کا جوش اس تقریب کو خاص بناتا ہے۔'
    },
    {
        id: 'final_opportunity_ur',
        title: 'آخری موقع',
        language: 'ur',
        message: 'یہ آپ کا آخری موقع ہے! ان ناقابل یقین اشیاء کو جانے نہ دیں - ابھی اپنی بولی لگائیں!'
    },
    {
        id: 'excitement_ur',
        title: 'جوش پیدا کریں',
        language: 'ur',
        message: 'بولی لگانے کا سلسلہ گرم ہو رہا ہے! کارروائی میں شامل ہوں اور اپنی پسندیدہ اشیاء کو حاصل کریں!'
    },
    {
        id: 'appreciation_ur',
        title: 'تعریف کا اظہار',
        language: 'ur',
        message: 'آپ کے صبر اور شرکت کی تعریف کی جاتی ہے۔ آپ کی بولی اس نیلامی کو کامیاب بنانے میں مدد کرتی ہے!'
    },
    {
        id: 'momentum_ur',
        title: 'رفتار برقرار رکھیں',
        language: 'ur',
        message: 'رفتار جاری رکھیں! ہر بولی اہم ہے اور سب کو ان شاندار لاتوں کو بند کرنے کے قریب لاتی ہے!'
    },
    {
        id: 'encourage_activity_ur',
        title: 'سرگرمی کی حوصلہ افزائی',
        language: 'ur',
        message: 'نیلامی پوری تیزی سے جاری ہے! شامل ہوں اور ایک جیتنے والی بولی کے ساتھ اپنا نشان بنائیں!'
    },
    {
        id: 'great_deals_ur',
        title: 'بہترین ڈیلز دستیاب',
        language: 'ur',
        message: 'شاندار ڈیلز آپ کا انتظار کر رہی ہیں! ہچکچائیں نہیں - یہ قیمتیں زیادہ دیر تک نہیں رہیں گی!'
    },
    {
        id: 'community_spirit_ur',
        title: 'برادری کی روح',
        language: 'ur',
        message: 'اس نیلامی برادری کا حصہ بننے کے لیے آپ کا شکریہ! آپ کی شرکت ایک بہترین ماحول پیدا کرتی ہے!'
    },
    {
        id: 'competitive_bidding_ur',
        title: 'مسابقتی بولی',
        language: 'ur',
        message: 'مقابلہ سخت ہے! اپنی عزم کا مظاہرہ کریں اور وہ جیتنے والی بولی لگائیں!'
    },
    {
        id: 'quality_items_ur',
        title: 'معیاری اشیاء',
        language: 'ur',
        message: 'یہ غیر معمولی اشیاء ہیں جو آپ کو کہیں اور نہیں ملیں گی! آج اپنی حفاظت کریں!'
    },
    {
        id: 'time_sensitive_ur',
        title: 'وقت حساس',
        language: 'ur',
        message: 'وقت ختم ہو رہا ہے! یقینی بنائیں کہ آپ ان شاندار لاتوں پر بولی لگانے کا موقع نہیں چھوڑتے!'
    },
    {
        id: 'success_stories_ur',
        title: 'کامیابی کی کہانیاں',
        language: 'ur',
        message: 'بہت سے بولی لگانے والوں نے آج اپنی پسندیدہ اشیاء پائی ہیں! آپ اگلے ہو سکتے ہیں - بولی لگاتے رہیں!'
    },
    {
        id: 'support_message_ur',
        title: 'تعاون کا پیغام',
        language: 'ur',
        message: 'آپ کی حمایت بہت اہم ہے! ہر بولی اس نیلامی کو بہت کامیاب بنانے میں مدد کرتی ہے!'
    },
    {
        id: 'energy_boost_ur',
        title: 'توانائی بڑھائیں',
        language: 'ur',
        message: 'آئیے توانائی کو زیادہ رکھیں! آپ کی فعال شرکت اس نیلامی کے جوش کو بڑھاتی ہے!'
    },
    {
        id: 'value_reminder_ur',
        title: 'قیمت کی یاد دہانی',
        language: 'ur',
        message: 'یاد رکھیں، یہ اشیاء ناقابل یقین قیمت کی نمائندگی کرتی ہیں! بہترین مواقع کو جانے نہ دیں!'
    },
    {
        id: 'auction_starting_ur',
        title: 'نیلامی شروع ہونے والی ہے',
        language: 'ur',
        message: 'بھائیو، نیلامی شروع ہونے والی ہے، سب تیار رہیں!'
    },
    {
        id: 'first_bid_question_ur',
        title: 'پہلا بول',
        language: 'ur',
        message: 'پہلا بول کس کا؟'
    },
    {
        id: 'encourage_no_shy_ur',
        title: 'بولی لگائیں شرمائیں نہیں',
        language: 'ur',
        message: 'جی ہاں، بول لگائیں، شرمائیں نہیں!'
    },
    {
        id: 'new_condition_item_ur',
        title: 'نئی حالت میں چیز',
        language: 'ur',
        message: 'یہ چیز بالکل نئی حالت میں ہے، موقع ہاتھ سے نہ جانے دیں!'
    },
    {
        id: 'starting_bid_announcement_ur',
        title: 'شروع ہونے والی بولی',
        language: 'ur',
        message: 'پانچ ہزار سے بول شروع!'
    },
    {
        id: 'bid_callout_5k_ur',
        title: 'بولی کا اعلان',
        language: 'ur',
        message: 'پانچ ہزار، پانچ ہزار، کوئی چھ ہزار دے گا؟'
    },
    {
        id: 'bid_acknowledgment_ur',
        title: 'بولی کی تصدیق',
        language: 'ur',
        message: 'جی ہاں، پیچھے والے صاحب نے چھ ہزار بول دیا!'
    },
    {
        id: 'higher_bid_callout_ur',
        title: 'زیادہ بولی کا اعلان',
        language: 'ur',
        message: 'سات ہزار، سات ہزار، اور کوئی بڑھائے گا؟'
    },
    {
        id: 'sold_announcement_ur',
        title: 'فروخت کا اعلان',
        language: 'ur',
        message: 'ایک بار، دو بار، تین بار... فروخت!'
    },
    {
        id: 'congratulations_ur',
        title: 'مبارکباد',
        language: 'ur',
        message: 'مبارک ہو، یہ چیز آپ کی ہوئی!'
    },
    {
        id: 'hurry_next_item_ur',
        title: 'جلدی کریں',
        language: 'ur',
        message: 'جلدی کریں، اگلی چیز آ رہی ہے!'
    },
    {
        id: 'unique_item_warning_ur',
        title: 'منفرد چیز',
        language: 'ur',
        message: 'بھائیو، ایسی چیز دوبارہ نہیں ملے گی!'
    },
    {
        id: 'increase_bid_valuable_ur',
        title: 'بولی بڑھائیں',
        language: 'ur',
        message: 'ریٹ بڑھائیں، چیز قیمتی ہے!'
    },
    {
        id: 'inspect_then_bid_ur',
        title: 'دیکھ بھال کر بولی لگائیں',
        language: 'ur',
        message: 'دیکھ لیں، جانچ لیں، پھر بول لگائیں!'
    },
    {
        id: 'last_chance_quick_ur',
        title: 'آخری موقع جلدی',
        language: 'ur',
        message: 'بس آخری موقع ہے، بول لگا لیں!'
    },
    // Urdu Templates - Roman English (Transliteration)
    {
        id: 'welcome_ur_roman',
        title: 'Khush Aamdeed',
        language: 'ur-roman',
        message: 'Live neelami mein khush aamdeed! Aap ko yahan dekh kar khushi ho rahi hai. Khush qismat boli!'
    },
    {
        id: 'encourage_bidding_ur_roman',
        title: 'Boli Lagane Ki Hosla Afzai',
        language: 'ur-roman',
        message: 'In shandar ashiya ko mat chhoriye! Abhi apni boli lagayein aur kuch khaas ghar le jayein!'
    },
    {
        id: 'thank_participants_ur_roman',
        title: 'Shurka Ka Shukriya',
        language: 'ur-roman',
        message: 'Aaj ki neelami mein shirkat ke liye aap sab ka shukriya! Aap ka josh is taqreeb ko khaas banaata hai.'
    },
    {
        id: 'final_opportunity_ur_roman',
        title: 'Aakhri Mauqa',
        language: 'ur-roman',
        message: 'Yeh aap ka aakhri mauqa hai! In naqabil yaqeen ashiya ko jaane na dein - abhi apni boli lagayein!'
    },
    {
        id: 'excitement_ur_roman',
        title: 'Josh Paida Karein',
        language: 'ur-roman',
        message: 'Boli lagane ka silsila garam ho raha hai! Karrawai mein shamil hon aur apni pasandida ashiya ko hasil karein!'
    },
    {
        id: 'appreciation_ur_roman',
        title: 'Tareef Ka Izhar',
        language: 'ur-roman',
        message: 'Aap ke sabr aur shirkat ki tareef ki jati hai. Aap ki boli is neelami ko kaamyaab banane mein madad karti hai!'
    },
    {
        id: 'momentum_ur_roman',
        title: 'Raftar Barqarar Rakhein',
        language: 'ur-roman',
        message: 'Raftar jari rakhein! Har boli aham hai aur sab ko in shandar laton ko band karne ke qareeb laati hai!'
    },
    {
        id: 'encourage_activity_ur_roman',
        title: 'Sargarmi Ki Hosla Afzai',
        language: 'ur-roman',
        message: 'Neelami poori taizi se jari hai! Shamil hon aur ek jeetne wali boli ke sath apna nishan banayein!'
    },
    {
        id: 'great_deals_ur_roman',
        title: 'Behtareen Deals Dastyab',
        language: 'ur-roman',
        message: 'Shandar deals aap ka intezar kar rahi hain! Hichkichaayein nahi - yeh qeematein zyada der tak nahi rahengi!'
    },
    {
        id: 'community_spirit_ur_roman',
        title: 'Baradri Ki Rooh',
        language: 'ur-roman',
        message: 'Is neelami baradri ka hissa banne ke liye aap ka shukriya! Aap ki shirkat ek behtareen mahol paida karti hai!'
    },
    {
        id: 'competitive_bidding_ur_roman',
        title: 'Musabqati Boli',
        language: 'ur-roman',
        message: 'Muqabla sakht hai! Apni azm ka muzahira karein aur woh jeetne wali boli lagayein!'
    },
    {
        id: 'quality_items_ur_roman',
        title: 'Miyari Ashiya',
        language: 'ur-roman',
        message: 'Yeh ghair mamooli ashiya hain jo aap ko kahin aur nahi milengi! Aaj apni hifazat karein!'
    },
    {
        id: 'time_sensitive_ur_roman',
        title: 'Waqt Hasas',
        language: 'ur-roman',
        message: 'Waqt khatam ho raha hai! Yaqeeni banayein ke aap in shandar laton par boli lagane ka mauqa nahi chhorte!'
    },
    {
        id: 'success_stories_ur_roman',
        title: 'Kaamyaabi Ki Kahaniyan',
        language: 'ur-roman',
        message: 'Bohat se boli lagane walon ne aaj apni pasandida ashiya paai hain! Aap agle ho sakte hain - boli lagate rahein!'
    },
    {
        id: 'support_message_ur_roman',
        title: 'Taa\'awun Ka Paigham',
        language: 'ur-roman',
        message: 'Aap ki himayat bohat aham hai! Har boli is neelami ko bohat kaamyaab banane mein madad karti hai!'
    },
    {
        id: 'energy_boost_ur_roman',
        title: 'Tawanai Barhayein',
        language: 'ur-roman',
        message: 'Aaye tawanai ko zyada rakhein! Aap ki fa\'al shirkat is neelami ke josh ko barhati hai!'
    },
    {
        id: 'value_reminder_ur_roman',
        title: 'Qeemat Ki Yaad Dehani',
        language: 'ur-roman',
        message: 'Yaad rakhein, yeh ashiya naqabil yaqeen qeemat ki numayindagi karti hain! Behtareen mauqaat ko jaane na dein!'
    },
    {
        id: 'auction_starting_ur_roman',
        title: 'Neelami Shuru Hone Wali Hai',
        language: 'ur-roman',
        message: 'Bhaiyo, neelami shuru hone wali hai, sab tayyar rahein!'
    },
    {
        id: 'first_bid_question_ur_roman',
        title: 'Pehla Bol',
        language: 'ur-roman',
        message: 'Pehla bol kis ka?'
    },
    {
        id: 'encourage_no_shy_ur_roman',
        title: 'Boli Lagayein Sharmayein Nahin',
        language: 'ur-roman',
        message: 'Ji haan, bol lagayein, sharmayein nahi!'
    },
    {
        id: 'new_condition_item_ur_roman',
        title: 'Nayi Haalat Mein Cheez',
        language: 'ur-roman',
        message: 'Yeh cheez bilkul nayi haalat mein hai, mauqa haath se na jaane dein!'
    },
    {
        id: 'starting_bid_announcement_ur_roman',
        title: 'Shuru Hone Wali Boli',
        language: 'ur-roman',
        message: 'Paanch hazaar se bol shuru!'
    },
    {
        id: 'bid_callout_5k_ur_roman',
        title: 'Boli Ka Elaan',
        language: 'ur-roman',
        message: 'Paanch hazaar, paanch hazaar, koi chhah hazaar dega?'
    },
    {
        id: 'bid_acknowledgment_ur_roman',
        title: 'Boli Ki Tasdeeq',
        language: 'ur-roman',
        message: 'Ji haan, peechhe wale sahib ne chhah hazaar bol diya!'
    },
    {
        id: 'higher_bid_callout_ur_roman',
        title: 'Zyada Boli Ka Elaan',
        language: 'ur-roman',
        message: 'Saat hazaar, saat hazaar, aur koi barhaye ga?'
    },
    {
        id: 'sold_announcement_ur_roman',
        title: 'Farokht Ka Elaan',
        language: 'ur-roman',
        message: 'Ek baar, do baar, teen baar... farokht!'
    },
    {
        id: 'congratulations_ur_roman',
        title: 'Mubarakbaad',
        language: 'ur-roman',
        message: 'Mubarak ho, yeh cheez aap ki hui!'
    },
    {
        id: 'hurry_next_item_ur_roman',
        title: 'Jaldi Karein',
        language: 'ur-roman',
        message: 'Jaldi karein, agli cheez aa rahi hai!'
    },
    {
        id: 'unique_item_warning_ur_roman',
        title: 'Munfarid Cheez',
        language: 'ur-roman',
        message: 'Bhaiyo, aisi cheez dobara nahi milegi!'
    },
    {
        id: 'increase_bid_valuable_ur_roman',
        title: 'Boli Barhayein',
        language: 'ur-roman',
        message: 'Rate barhayein, cheez qeemti hai!'
    },
    {
        id: 'inspect_then_bid_ur_roman',
        title: 'Dekh Bhaal Kar Boli Lagayein',
        language: 'ur-roman',
        message: 'Dekh lein, jaanch lein, phir bol lagayein!'
    },
    {
        id: 'last_chance_quick_ur_roman',
        title: 'Aakhri Mauqa Jaldi',
        language: 'ur-roman',
        message: 'Bas aakhri mauqa hai, bol laga lein!'
    }
];

/**
 * Get templates by language
 * @param {string} language - Language code ('en', 'ur', 'ur-roman', or 'both')
 * @returns {array} - Filtered templates
 */
export const getTemplatesByLanguage = (language) => {
    if (language === 'both') {
        return announcementTemplates;
    }
    // For 'ur', also include 'ur-roman' templates
    if (language === 'ur') {
        return announcementTemplates.filter(t => t.language === 'ur' || t.language === 'ur-roman' || t.language === 'both');
    }
    return announcementTemplates.filter(t => t.language === language || t.language === 'both');
};

/**
 * Get template by ID
 * @param {string} templateId - Template ID
 * @returns {object|null} - Template object or null
 */
export const getTemplateById = (templateId) => {
    return announcementTemplates.find(t => t.id === templateId) || null;
};
